import { render, staticRenderFns } from "./QuestionnaireCard_SUS.vue?vue&type=template&id=07a40d9e&scoped=true&"
import script from "./QuestionnaireCard_SUS.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireCard_SUS.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireCard_SUS.vue?vue&type=style&index=0&id=07a40d9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a40d9e",
  null
  
)

export default component.exports